import VerifyAccount from '../../../components/Auth/VerifyAccount/VerifyAccount';
import Header from '../../../components/Header/Header';
import { HeaderTypeEnum } from '../../../enums/header-type';
import { useSelector } from 'react-redux';
import { selectAuthData } from '../../../store/selectors/authSelector';
import Footer from '../../../components/Header/Footer/Footer';

const VerifyAccountPage = () => {
  const authData = useSelector(selectAuthData);
  const role = authData?.user?.role;
  return (
    <>
      <Header type={HeaderTypeEnum.VERIFY_ACCOUNT} />
      <VerifyAccount role={role} />
      <Footer />
    </>
  );
};

export default VerifyAccountPage;
